// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// Function to check if analytics is likely to be blocked
const isAnalyticsLikelyBlocked = () => {
  // Check for common signs of content blockers
  return window.doNotTrack === "1" || 
         navigator.doNotTrack === "1" || 
         navigator.doNotTrack === "yes";
};

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBDLoVyDDX_SS9eS_Q7IuCy5Shyv4-T5N8",
  authDomain: "trinitypwa-69b4e.firebaseapp.com",
  projectId: "trinitypwa-69b4e",
  storageBucket: "trinitypwa-69b4e.firebasestorage.app",
  messagingSenderId: "420286184733",
  appId: "1:420286184733:web:2e312a845026acdb29b5f4",
  measurementId: "G-80Q8S907ZR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment and if not likely blocked)
let analytics = null;
if (typeof window !== 'undefined' && !isAnalyticsLikelyBlocked()) {
  try {
    analytics = getAnalytics(app);
    console.log("Analytics initialized successfully");
  } catch (error) {
    console.log("Analytics initialization skipped or failed");
  }
}

// Initialize Storage
const storage = getStorage(app);

// Export Firebase services
export { app, storage, analytics };